<template>
    <div class="main-container">
        <div class="brandcontainer hidden-sm-and-down">
            <div class="container">
                <h4>媒体资讯</h4>
                <div class="video_news">
                    <el-row :gutter="20" style="width:99%">
                        <el-col :span="12">
                            <div class="content_left">
                                <div class="bntbox">
                                    <el-button class="videobtn">视频</el-button>
                                </div>
                                 <el-carousel style="max-width:442px;margin:0 auto" :interval="54000" arrow="always" :height="videoheight+'px'" @change="paly">
                                    <el-carousel-item v-for="(item,index) in videolist" :key="index">
                                      <video ref="videoheight" autoplay="index==0?true:false" muted loop style="width:100%;" :id="'pc_player'+index">
                                        <source :src="videourl + item.video" type="video/mp4" />
                                      </video>
                                    </el-carousel-item>
                                </el-carousel>
                                <p class="title">刘燕酿制</p>
                                <p class="detail">明星＆节目同款好物</p>
                            </div>
                        </el-col>
                         <el-col :span="12">
                            <div class="contentrig">
                               <div class="bntbox">
                                    <el-button class="leftbtn">新闻</el-button>
                                    <el-button class="rigbtn">媒体</el-button>
                                </div>
                                <ul class="newlist"> 
                                    <li class="tab-gn" v-for="(item,index) in newslist"  :key="index">
                                        <router-link v-if="item.show_type == 1" :to='"newDetail" +"?id="+item.id '  class="titele">
                                        {{ (currentPage-1)*6+(index+1) }}、{{item.title}}
                                        </router-link>
                                        <span v-if="item.show_type == 1" style="float:right;color: #b71417;">百科</span>
                                        <a  :href="item.outside_url" target="_blank" v-if="item.show_type == 2" class="titele"> {{ (currentPage-1)*6+(index+1) }}、{{item.title}}</a>
                                        <span style="float:right;color: #b71417;">{{ item.source }}</span>
                                        </li>
                                </ul>
                              
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div class="container_bto">
                       <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="bto_left">
                                    <img @click="leftbtn" class="leftbtn" src="../../static/brand2.png" alt="">
                                    <img @click="rigbtn" class="rigbtn" src="../../static/brand1.png" alt="">
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="bto_rig">
                                      <el-pagination
                                        background
                                        :page-size="6"
                                        layout="prev, pager, next"
                                        @current-change="getnewList()"
                                        :current-page.sync="currentPage"
                                        :total="total">
                                    </el-pagination>
                                </div>
                            </el-col>
                        </el-row>
                </div>
            </div>
        </div>
        <!-- 手机端显示 -->
        <div class="hidden-md-and-up" style="min-height:100vh">
            <div class="brandtab">
                <ul>
                <li @click="cur=0"><span >媒体报道</span><i :class="{actives:cur==0}"></i></li>
                <li @click="cur=1"><span >品牌权威</span><i :class="{actives:cur==1}"></i></li>
                <li @click="slieClick"><span >品牌历程</span><i :class="{actives:cur==2}"></i></li>
                </ul>
            </div>
            <div class="tab-content">
                <div v-if="cur==0" class="videonew">
                    <h1>明星＆节目同款好物</h1>
                    <div class="videobox">
                        <el-carousel style="width:100%;" :interval="54000" arrow="always" height="3.32rem" @change="paly">
                            <el-carousel-item v-for="(item,index) in videolist" :key="index">
                                <video ref="videoheight" controls="true"  muted loop style="width:100%;" :id="'moble_player'+index">
                                <source :src="videourl + item.video" type="video/mp4" />
                                </video>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <div class="newline">
                        <p>
                            <span>新闻</span>
                            <span>媒体</span>
                        </p>
                        <ul class="mobnewlist"> 
                            <li class="tab-gn" v-for="(item,index) in newslist"  :key="index">
                                        <router-link v-if="item.show_type == 1" :to='"newDetail" +"?id="+item.id '  class="titele">
                                        {{ (currentPage-1)*6+(index+1) }}、{{item.title}}
                                        </router-link>
                                        <span v-if="item.show_type == 1" style="float:right;color: #b71417;">百科</span>
                                        <a  :href="item.outside_url" target="_blank" v-if="item.show_type == 2" class="titele"> {{ (currentPage-1)*6+(index+1) }}、{{item.title}}</a>
                                        <span style="float:right;color: #b71417;">{{ item.source }}</span>
                                        </li>
         
                        </ul>
                    </div>
                    <div style="padding-bottom:1rem;">
                        <el-pagination
                            background
                            :page-size="6"
                            layout="prev, pager, next"
                            @current-change="getnewList()"
                            :current-page.sync="currentPage"
                            :total="total">
                        </el-pagination>
                    </div>
                </div>
                <div v-if="cur==1">
                    <Brandauthority/>
                </div>
                <div style="width:100%;height:100vh" v-if="cur==2" >
                    <iframe id="ifra" scrolling="auto" width="100%" height="100%" src="../../static/Brand_history/document.html" frameborder="0"></iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {video_url,news_url,get_article_cate_url} from '../request/api'
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import Brandauthority from './Brand_authority'
export default {
    name: 'NewLiuyanShopWebBrand',
    components: { swiper,swiperSlide,Brandauthority},
    directives: {  },
    data() {
        return {
            videolist:[],
            videourl:'https://cdnunified.liuyanniangzhi.com/uploads/video/',
            videoheight:'',
            newslist:[],
            currentPage: 1,
            total: null,
            cur:0,
            id:'',
        };
    },

    mounted() {
        get_article_cate_url().then((res)=>{
             let arrlist = res.data.data
            for(var i = 0;i<arrlist.length;i++){
              if(arrlist[i].title == '媒体见证'){
              this.id = arrlist[i].id
              this.getVideo()
              }
            }
        })
        this.getnewList()
     
        if(this.$route.query.id == 2){
            this.cur = this.$route.query.id
        }
    
        this.videoheight = 225
        this.videoload();
        window.addEventListener('resize',() => {
                if(this.$refs.videoheight){
                this.videoheight = this.$refs.videoheight[0].clientHeight 
                this.videoload();
                }
                },false)
    },

    methods: {
        paly(now,old){
            if(window.innerWidth>768){
                document.querySelector('#pc_player'+now).play()
                document.querySelector('#pc_player'+old).pause()
            }else{
                document.querySelector('#moble_player'+now).play()
                document.querySelector('#moble_player'+old).pause()
            }
        },
        videoload(){
            this.$nextTick(()=>{
                if(this.$refs.videoheight){
                     this.videoheight = this.$refs.videoheight[0].clientHeight
                }
               
            })
        },
        getnewList(){
            news_url({article_cate_id:3 , page:this.currentPage }).then((res)=>{
                this.newslist = res.data.data.data
                this.total = res.data.data.count
            })
        },
        leftbtn(){
                    this.$router.push({ path:'/Brand_authority'})
        },
        rigbtn(){
             this.$router.push({ path:'/Brandhistory'})
        },
        slieClick(){
            this.cur = 2
            this.$router.push({path:'/Brand',query:{id:2}})
        },
        // 视频列表
        getVideo(){
               video_url({ article_cate_id:this.id , page:this.currentPage }).then((res)=>{
                   let arr = res.data.data.data
                    this.videolist = arr.splice(0,1)
             })
        }
    },
    created(){
       
    }
};
</script>

<style lang="less" scoped>
/deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #fff;
}
/deep/.el-pagination.is-background .el-pager li{
    background-color:#CBCBCB;
    color: #fff;
}/deep/.active{
    background-color:#00383F!important;
}
/deep/.el-pager li{
    width: 50px!important;
    height: 50px!important;
    line-height: 50px!important;
    font-size: 30px!important;
    font-weight: 300!important;
}
/deep/.el-pagination .btn-prev{
    width: 50px!important;
    height: 50px!important;
    background-color:#CBCBCB!important;
}
/deep/.el-pagination.is-background .btn-prev:disabled{
    color: unset;
}
/deep/.el-pagination.is-background .btn-next:disabled{
    color: unset;
}
/deep/.el-pagination .btn-next{
     width: 50px!important;
    height: 50px!important;
     background-color:#CBCBCB!important;
}
/deep/.el-pagination .btn-next .el-icon{
    font-size: 25px!important;
}
/deep/.el-pagination .btn-prev .el-icon{
    font-size: 25px!important;
}
/deep/.el-carousel__indicators--horizontal{
    display: none;
}
.brandcontainer{
    height: 100%;
     width: 100%;
        // min-height:calc(100vh - 300px);
        .container{
            margin: 0 auto;
            width: 80%;
            max-width: 1200px;
            height: 100%;
        .container_bto{
            width: 100%;
            padding-top: 5%;
            padding-bottom: 10%;
            .bto_left{
              .leftbtn{
                  width: 40%;
                  float: left;
              }
              .rigbtn{
                  float: right;
                  width: 40%;
              }
                img{
                    width: 100%;
                }
            }
            .bto_rig{
                margin-top: 2%;
                margin-right: 3%;
            }
         
        }
       
            h4{
                font-size: 26px;
                font-family: Source Han Serif CN;
                font-weight: 500;
                color: #00383F;
                line-height: 32px;
                padding-top: 3%;
                text-align: left;
                padding-bottom: 1%;
                border-bottom: 1px solid #00383F;
            }
            .video_news{
                width: 100%;
                .content_left{
                    width: 100%;
                          .bntbox{
                            text-align: left;
                            margin-top: 5%;
                            padding-bottom: 6%;
                        .videobtn{
                            background: #00383F;
                            border-radius: 5px;
                            color: #fff;
                            font-size: 20px;
                        }
                 
                    }
                   .title{
                        font-size: 26px;
                        margin-top: 5%;
                        font-weight: 400;
                    }
                    .detail{
                          font-size: 26px;
                           padding-top: 2%;
                            font-weight: 400;
                    }
                    .linkbtn{
                        margin-bottom: 30%;
                        margin-top: 15%;
                         overflow: hidden;
                 
                    }
                }
                .contentrig{
                    padding-left: 5%;
                     width: 100%;
                    .bntbox{
                          text-align: left;
                            margin-top: 5%;
                            margin-bottom: 6%;
                            overflow: hidden;
                        .leftbtn{
                            float: left;
                            background: #00383F;
                            border-radius: 5px;
                            color: #fff;
                            font-size: 20px;
                            
                        }
                        .rigbtn{
                            float:right;
                            background: #00383F;
                            border-radius: 5px;
                            color: #fff;
                            font-size: 20px;
                        }
                    }
                    .newlist{
                        float: left;
                        text-align: left;
                        width: 100%;
                        li{   
                            font-size: 20px;
                            margin-bottom:5%;
                            border-bottom: 1px solid;
                            padding-bottom: 0.6%;
                            a{
                                display: inline-block;
                                width: 69%;
                                overflow:hidden;
                                white-space:nowrap;
                                text-overflow: ellipsis;
                            }
                            span{
                                display: inline-block;
                                float: right;
                            }
                        }
                    }
                 
                }
          
            }
        }
}
 @media (max-width: 991px) {
/deep/.el-pagination .btn-prev{
    width: 0.438rem!important;
    height: 0.438rem!important;
    background-color:#CBCBCB!important;
}
/deep/.el-pagination .btn-next{
    width: 0.438rem!important;
    height: 0.438rem!important;
}
/deep/.el-pagination .btn-prev .el-icon {
    font-size: 0.2rem!important;
}
/deep/.el-pagination .btn-next .el-icon {
    font-size: 0.2rem!important;
}
/deep/.el-pager li{
    font-size: 0.26rem!important;
  width: 0.438rem!important;
    height: 0.438rem!important;
    line-height: 0.438rem!important;
}
     .brandtab{
         height: 1.14rem;
         border-bottom: 1px solid #00383F;
         margin: 0 0.15rem;
         ul{
             display: flex;
             width: 100%;
             height: 1.13rem;
             li{
                 width: 33.3%;
                 font-size: 0.34rem;
                 font-weight: 900;
                 position: relative;
                 span{
                    display: inline-block;
                     padding-top: 0.52rem;
                     width: 1.7rem;
                 }
                  .actives{
                    display: inline-block;
                    display: inline-block;
                    width: 1.49rem;
                    height: 0.06rem;
                    background:#00383F ;
                    position: absolute;
                    bottom: -0.01rem;
                    left: 50%;
                    transform: translateX(-50%);
                    }
             }
         }
     }
     .tab-content{
         .videonew{
             h1{
                 font-size: 0.36rem;
                 padding-top: 0.59rem;
                 padding-bottom: 0.29rem;
             }
             .videobox{
                 margin: 0 0.8rem;
                 height: 3.32rem;
             }
             .newline{
                 padding: 0.6rem 0.6rem 0.56rem 0.6rem;
                 p{
                     width: 100%;
                     overflow: hidden;
                     span{
                         width: 1rem;
                         background: #00383F;
                         color: #fff;
                         display: inline-block;
                         font-size: 0.3rem;
                         padding: 0.07rem 0;
                         float: left;
                     }
                     span:nth-child(2){
                         float: right;
                     }
                 }
                 .mobnewlist{
                     text-align: left;
                     li{
                         padding-bottom: 0.11rem;
                         border-bottom: 1px solid rgba(0, 56, 63, 0.5);
                         padding-top: 0.26rem;
                         font-weight: bold;
                         font-size: 0.24rem;
                         a{
                                display: inline-block;
                                width: 70%;
                                overflow:hidden;
                                white-space:nowrap;
                                text-overflow: ellipsis;
                            }
                            span{
                                display: inline-block;
                                float: right;
                            }
                     }
                         
                 }
             }
         }
     }
     /deep/.el-carousel__arrow{
         background-color:unset;
     }

 
 }


</style>


// WEBPACK FOOTER //
// src/view/Brand.vue